import { render, staticRenderFns } from "./SchemaFormGlobalErrors.vue?vue&type=template&id=d0748cfe"
import script from "./SchemaFormGlobalErrors.vue?vue&type=script&lang=js"
export * from "./SchemaFormGlobalErrors.vue?vue&type=script&lang=js"
import style0 from "./SchemaFormGlobalErrors.vue?vue&type=style&index=0&id=d0748cfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports